// src/component/datatable2/components/DataTableToolbar.tsx

import React from 'react';
import { useTranslation } from 'react-i18next';
import { InputText } from 'primereact/inputtext';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { ReactComponent as SearchIcon } from '../../../assets/images/search-icon.svg';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import './DataTableToolbar.scss';

export type GlobalSearchPosition = 'left' | 'right' | 'none';

interface Props {
    left?: React.ReactNode;
    right?: React.ReactNode;
    bottom?: React.ReactNode;
    globalSearchPosition: GlobalSearchPosition;
    baseQuery: string | undefined;
    onBaseQueryChange: (value: string) => void;
    /** Ref to the search input, e.g. to focus it with a keyboard shortcut. */
    searchInputRef?: React.Ref<HTMLInputElement>;
}

/**
 * Toolbars above the table, with the global search on the left or right.
 * Used by DataTable2 and by the report grid pages, so table toolbars look the same everywhere.
 */
export const DataTableToolbar: React.FC<Props> = ({
    left,
    right,
    bottom,
    globalSearchPosition,
    baseQuery,
    onBaseQueryChange,
    searchInputRef,
}) => {
    const { t } = useTranslation();

    const globalSearch = (
        <span className="p-input-icon-left">
            <InputText
                ref={searchInputRef}
                variant="filled"
                className="search-input small"
                placeholder={t('dataTable.search')}
                aria-label={t('dataTable.search')}
                value={baseQuery ?? ''}
                onChange={event => onBaseQueryChange(event.target.value)}
            />
            <SearchIcon />
        </span>
    );

    const showTopToolbar = Boolean(left || right || bottom || globalSearchPosition !== 'none');

    return (
        <>
            {showTopToolbar && (
                <>
                    <div className="table-toolbar dt2-toolbar">
                        <div className="table-toolbar__content table-toolbar__content--left">
                            {globalSearchPosition === 'left' && globalSearch}
                            <div>{left}</div>
                        </div>
                        <div className="table-toolbar__content table-toolbar__content--right">
                            {globalSearchPosition === 'right' && globalSearch}
                            {right}
                        </div>
                    </div>
                    <div className="separator dt2-separator" />
                </>
            )}

            {bottom && (
                <>
                    <div className="table-toolbar dt2-toolbar">
                        <div className="table-toolbar__content">{bottom}</div>
                    </div>
                    <div className="separator dt2-separator" />
                </>
            )}
        </>
    );
};
